import { combineReducers } from "redux";
import login from "../containers/Auth/Login/reducer";
import signup from "../containers/Auth/SignUp/reducer";
import SearchHedgeFundStore from "../containers/SearchHedgeFund/reducer";
import chat from "../containers/Chat/reducer";
import manage from "../containers/ManageSchedule/reducer";
import hedgeFundDetailStore from "../containers/FundDetail/reducer";
import dashboard from "../containers/DashBoard/reducer";
import meetings from "../containers/Profile/MyMeetingsTab/reducer";
import investedFunds from "../containers/MyFunds/reducer";
import appointment from "../containers/Meeting/reducer";
import profile from "../containers/Profile/reducer";
import userDetails from "../containers/UpdateUser/reducer";
import createNewUsers from "../containers/CreateNewUser/reducer";
import createNewPosts from "../containers/CreateNewPost/reducer";
import getNewPosts from "../containers/NewsFeed/reducer";
import getMyPosts from "../containers/Profile/MyPosts/reducer";
import meetingDetails from "../containers/MeetingDetail/reducer";
import createFCNQuery from "../containers/ContactFCNAdmin/reducer";
import documentDetail from "../containers/DocumentDetail/reducer";
import alertFactory from "../containers/App/ProtectedApp/reducer";
import forgetPassword from "../containers/Auth/ForgetPassword/reducer";
import resetPassword from "../containers/Auth/RestPassword/reducer";
import Impersonationlogin from "../containers/Auth/Impersonation/reducer"
import fundCompare from "../containers/FundCompare/reducer"
import allocatorNetwork from "../containers/AllocatorNetwork/reducer"
import allocatorProfile from "../containers/AllocatorProfile/reducer"
import UserPreferencesStore from "../containers/UserPreference/reducer"
import CloudDocumentStore from "../containers/CloudDocument/reducer"
import AllocatorContactStore from "../containers/AllocatorContact/reducer"

export default combineReducers({
  login,
  dashboard,
  signup,
  chat,
  SearchHedgeFundStore,
  manage,
  hedgeFundDetailStore,
  meetings,
  investedFunds,
  appointment,
  profile,
  userDetails,
  createNewUsers,
  createNewPosts,
  getNewPosts,
  getMyPosts,
  meetingDetails,
  createFCNQuery,
  documentDetail,
  alertFactory,
  forgetPassword,
  resetPassword,
  Impersonationlogin,
  fundCompare,
  allocatorNetwork,
  allocatorProfile,
  UserPreferencesStore,
  CloudDocumentStore,
  AllocatorContactStore,
});
